<div
  class="answer-card"
  [class.selected]="selected"
  [class.editing]="isEditing"
>
  <div class="answer-inner">
    <div class="answer-header">
      <div class="answer-author">
        <app-user-avatar
          [userEmail]="answer.userEmail"
          [size]="28"
          class="answer-author-avatar"
        ></app-user-avatar>
        <div class="answer-author-text">
          <span class="answer-author-name"
            >{{ (configService.userMap$|async)?.[answer.userEmail] || answer.userEmail }}
          </span>
          <span class="answer-author-date"
            >{{ answer.dateCreated | timeAgo }}
          </span>
        </div>
      </div>
      <div class="answer-actions">
        <app-svg-icon
          icon="more-horizontal"
          [size]="24"
          [strokeWidth]="3"
          color="var(--color-primary)"
          [attr.answerId]="answer.id"
          class="menu-icon"
        />
        <dx-context-menu
          [target]="'[answerId=\'' + answer.id + '\']'"
          showEvent="click"
          [items]="contextMenuItems"
          [elementAttr]="{ class: 'gpd-context-menu' }"
          cssClass="gpd-context-menu"
          (onItemClick)="onContextMenuItemClick($event)"
        ></dx-context-menu>
      </div>
    </div>

    <!-- Display Mode -->
    <div #contentContainer class="answer-content" *ngIf="!isEditing">
      <div [innerHTML]="displayContent"></div>
    </div>
    <span
      *ngIf="(isContentTruncated || showFullContent) && !isEditing"
      class="view-more-btn"
      (click)="toggleContent()"
      tabindex="0"
      role="button"
    >
      <span *ngIf="showFullContent" i18n="@@viewLess">View Less</span>
      <span *ngIf="!showFullContent" i18n="@@viewMore">View More</span>
    </span>

    <!-- Edit Mode -->
    <div class="answer-edit-section" *ngIf="isEditing">
      <app-answer-editor
        placeholder="Edit your answer..."
        i18n-placeholder="@@editAnswer"
        [content]="answer.content"
        [autofocus]="true"
        [disabled]="submittingEdit"
        (submitted)="saveEdit($event)"
        (cancelled)="cancelEdit()"
      ></app-answer-editor>
      <div class="answer-edit-footer">
        <div class="answer-edit-actions">
          <button
            class="answer-edit-cancel-btn"
            (click)="cancelEdit()"
            [disabled]="submittingEdit"
          >
            <span i18n="@@cancel">Cancel</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
